const PromotionsBackend = {
  invoke: {
    startPromotions: async ([socketId, viewMode]: [string, string]) => {
      const { state } = await window.WH.bootstrapper!.features[
        'promotions-flow'
      ].getState();

      if (state === 'STOPPED') {
        return window.WH.bootstrapper!.features['promotions-flow'].start({
          containerSelector: `#${socketId}`,
          viewMode,
        });
      }
    },
    stopPromotions: async () => {
      const { state } = await window.WH.bootstrapper!.features[
        'promotions-flow'
      ].getState();

      if (state !== 'STOPPED') {
        window.WH.bootstrapper!.features['promotions-flow'].stop();
      }
    },
  },
};

export default PromotionsBackend;
